<template>
	<div class="edit_user">
		<div class="header">My account</div>
		<div class="edit_item flex">
			<div class="name">Profile picture:</div>
			<el-upload
			  class="avatar-uploader"
			  action="https://api.curiouser-family.com/api/common/upload"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess">
			  <img v-if="userInfo.avatar" :src="imgBaseUrl+userInfo.avatar" class="avatar">
			 <img v-else src="../../../assets/images/icon/upload.png" alt="">
			</el-upload>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">First name：</div>
			<div class="val">
				<input type="text" v-model="userInfo.first_name" placeholder="">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Last name：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.last_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name"> Address line 1</div>
			<div class="val">
				<input type="text" placeholder="Flat/ House Number/ Name" v-model="userInfo.address_line_one">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name"> Address line 2：</div>
			<div class="val">
				<input type="text" placeholder="Street name"  v-model="userInfo.address_line_two">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Town：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.town">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Postcode：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.psot_code">
			</div>
		</div>
		<!-- <div class="edit_item flex align-center">
			<div class="name">Email：</div>
			<div class="val">
				<input type="text" placeholder="请输入" >
			</div>
		</div> -->
		<div class="edit_item flex align-center">
			<div class="name">Mobile:</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.mobile">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Note：</div>
			<div class="val">
				<input type="text" placeholder="Anything you'd like us to know" v-model="userInfo.remark">
			</div>
		</div>
		<!-- <div class="edit_item flex align-center">
			<div class="name">备注：</div>
			<div class="val">
				<input type="text" placeholder="请输入">
			</div>
		</div> -->
		<div class="btn_list flex align-center">
			<div class="btn" @click="back">Cancel</div>
			<div class="btn save" @click="changeUser">Save</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				imageUrl:'',
				userInfo:{},
			}
		},
		created(){
			this.getDetail()
		},
		methods:{
			handleAvatarSuccess(file){
				console.log(file)
				this.userInfo.avatar = file.data.url;
			},
			changeUser(){
				var params = {
					first_name:this.userInfo.first_name,
					last_name:this.userInfo.last_name,
					avatar:this.userInfo.avatar,
					address_line_one:this.userInfo.address_line_one,
					address_line_two:this.userInfo.address_line_two,
					town:this.userInfo.town,
					psot_code:this.userInfo.psot_code,
					remark:this.userInfo.remark,
					mobile:this.userInfo.mobile
				}
				this.$api.post('user/profile',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						this.$root.$emit('changeUser')
					}else{
						this.$message(res.msg)
					}
				})
			},
			back(){
				this.$router.back()
			},
			getDetail(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.edit_user{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 0 40px 60px;
		.header{
			width: 100%;
			height: 90px;
			line-height: 90px;
			border-bottom: 1px solid #5C707A;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.edit_item{
			margin-top: 30px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			.name{
				width: 188px;
				margin-right: 15px;
				text-align: right;
			}
			::v-deep .avatar-uploader{
				width: 122px;
				height: 122px;
			}
			::v-deep .el-upload{
				width: 100%;
				height: 100%;
			}
			::v-deep .avatar-uploader .avatar{
				width: 100%;
				height: 100%;
			}
			.val{
				width: 464px;
				height: 58px;
				border: 1px solid #282E30;
				border-radius: 10px;
				input{
					width: 100%;
					height: 100%;
					padding: 0 30px;
					line-height: 58px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #999999;
				}
			}
		}
		.btn_list{
			margin-top: 90px;
			padding-left: 230px;
			.btn{
				margin-right: 50px;
				width: 181px;
				height: 57px;
				border: 2px solid #5C707A;
				border-radius: 29px;
				line-height: 57px;
				text-align: center;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				cursor: pointer;
				&.save{
					background: #5C707A;
					color: #F7F2EB;
				}
			}
		}
	}
</style>